import { TOOLTIPS } from 'app/constants/TOOLTIPS';
import { AppNameComponent } from './data-widgets/app-name.component';
import { DomainNameComponent } from './data-widgets/domain-name.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { RankGradeComponent } from './data-widgets/rank-grade.component';
import { ReportConfig } from './REPORT_CONFIG';
import { GridHeaderWithTooltipComponent } from './data-widgets/grid-header-with-tooltip.component';

export const REPORT_CONFIG_HIGH_RISK_MFA: ReportConfig = {
  key: 'high-risk-mfa',
  heading: 'Made For Advertising (MFA)',
  title: 'Made For Advertising',
  formTitle: 'Made for Advertising rankings',
  pageTitle: 'High Risk Made for Advertising {types}',
  pageMeta:
    "Explore Pixalate's comprehensive list of high-risk MFA sites, categorized using our groundbreaking, multi-platform MFA Risk Detection system designed to identify and evaluate 'Made for Advertising' (MFA) threats across web, mobile, and CTV platforms.",
  reportId: 'mfaIndex',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  rowLimit: 10,
  fadeStart: 3,
  mainFilterItems: [
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [],
      options: []
    }
  ],
  notHideDataIfNA: true,
  gridHeaders: [
    {
      label: 'Rank',
      key: 'rank',
      sort: '',
      sortDefault: false,
      sortColumnKey: '',
      hoverKey: '',
      template: null,
      hidden: false,
      widgetComponent: RankDataComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'App Name',
      key: 'appTitle',
      groups: ['app', 'ctv'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: AppNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Domain',
      key: 'adDomain',
      groups: ['domain'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: DomainNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Final Score',
      key: 'mfaFinalScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        default: TOOLTIPS.mfaFinalScore
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Ad Refresh Score',
      key: 'noOfAdsScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      tooltipText: {
        domain:
          'Based on the number of ad impressions presented to a user per minute.'
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Ad Density Score',
      key: 'noOfPlacementScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      tooltipText: {
        domain: 'Based on the number of ad placements found on a page.'
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Inorganic Traffic Score',
      key: 'socialPaidRateScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      tooltipText: {
        domain:
          'Based on the amount of traffic sourced via paid sources (ads) or social media sources.'
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    }
  ]
};
